import Joi from 'joi';
import { forConversation } from '../channels';
import type { ExtractValues } from '../helpers';
import { actionCreator, objectSchemaOf } from '../helpers';

export const SHOW_KEYBOARD = 'USER_INPUT/SHOW_KEYBOARD';

export const requestFieldKeys = [
  'visitorName',
  'staffName',
  'deliveryWho',
  'companyName',
  'password',
] as const;

export const requestFieldKeySchema = Joi.string().valid(...requestFieldKeys);

export type RequestFieldKey = ExtractValues<typeof requestFieldKeys>;

export const requestedBy = ['hil', 'bot'] as const;

export const requestedBySchema = Joi.string().valid(...requestedBy);

export type RequestedBy = ExtractValues<typeof requestedBy>;

export const requestReasons = [
  'intervention',
  'silence',
  'empty-slot',
  'low-confidence',
  'multiple-matched',
  'no-match',
  'intent',
] as const;

export const requestReasonsSchema = Joi.string().valid(...requestReasons);

export type RequestReasons = ExtractValues<typeof requestReasons>;

export interface IShowKeyboardPayload {
  conversationId: string;
  inputKey: RequestFieldKey;
  label: string;
  placeholder?: string;
  message?: string; // message to be read aloud by Aimee.
  requestedBy?: RequestedBy;
  reason?: RequestReasons;
  reasonDescription?: string;
  disableGratitudeReply?: boolean;
}

export const showKeyboardPayloadSchema = objectSchemaOf<IShowKeyboardPayload>({
  conversationId: Joi.string().required(),
  inputKey: requestFieldKeySchema.required(),
  label: Joi.string().required(),
  placeholder: Joi.string(),
  message: Joi.string(),
  requestedBy: requestedBySchema.optional(),
  reason: requestReasonsSchema.optional(),
  reasonDescription: Joi.string().optional(),
  disableGratitudeReply: Joi.boolean().optional(),
});

export interface IShowKeyboardAction {
  type: typeof SHOW_KEYBOARD;
  payload: IShowKeyboardPayload;
}

export const showKeyboardActionSchema = objectSchemaOf<IShowKeyboardAction>({
  type: Joi.string().required().valid(SHOW_KEYBOARD),
  payload: showKeyboardPayloadSchema.required(),
});

export const showKeyboard = actionCreator({
  type: SHOW_KEYBOARD,
  schema: showKeyboardActionSchema,
  channels: [forConversation],
});
